import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Button from '../../components/Button';

import ImageArrowLine from '../../assets/arrow-line-dashed.jpeg';
import ImageAbout1 from '../../assets/about.jpg';
import ImageAbout2 from '../../assets/about-2.jpg';
import ImageFaq from '../../assets/faq.svg'

import { LandingContainer } from './styles';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

function Landing() {
  useEffect(() => {
    Array.from(document.querySelectorAll('.faq-items .faq-item')).forEach(faqItem => {
      faqItem.addEventListener('click', handleFaqItems);
    });
  }, []);

  function handleFaqItems({ target }: any) {
    if (target.classList.contains('active')) return target.classList.remove('active');

    const faqQuestions = Array.from(document.querySelectorAll('.faq-items .faq-item'));

    faqQuestions.forEach(faqQuestion => faqQuestion.classList.remove('active'));

    target.classList.add('active');
  }

  return (
    <LandingContainer>
      <Header page="home" />

      <section id="banner">
        <div className="content">
          <div className="text">
            <h1>Uma Revolução no food delivery</h1>

            <p>
              Vamos reduzir em 80% o custo operacional do food delivery! Você vai
              aumentar a sua receita com um custo operacional dos sonhos e vai
              perceber um maior lucro real.
            </p>

            <div className="buttons">
              <Button>Saiba mais</Button>
              <Button outline>Saiba mais</Button>
            </div>
          </div>

          <div className="asset">
            <div className="square first"></div>
            <div className="square second"></div>
            <div className="square third"></div>
            <div className="square fourth"></div>
            <div className="square fifth"></div>
          </div>
        </div>

        <div className="scroll-indicator">
          <div className="mouse">
            <div className="scroll"></div>
          </div>
        </div>
      </section>

      <section id="how-it-works">
        <div className="shadow"></div>

        <div className="content">
          <div className="heading">
            <h1>Veja como é fácil <br />fazer parte do nosso ecossistema</h1>
          </div>

          <div className="grid-steps">
            <div className="steps">
              <div className="step">
                <h1>1</h1>
                <div>
                  <h2>Fazer o cadastro</h2>
    
                  <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Reiciendis, cupiditate ratione. Exercitationem, at enim
                  </p>
                </div>
              </div>
              <div className="step">
                <h1>2</h1>
                <div>
                  <h2>Crie a sua loja</h2>
    
                  <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Reiciendis, cupiditate ratione. Exercitationem, at enim
                  </p>
                </div>
              </div>
              <div className="step">
                <h1>3</h1>
                <div>
                  <h2>Alcance clientes</h2>

                  <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Reiciendis, cupiditate ratione. Exercitationem, at enim
                  </p>
                </div>
              </div>

              <div className="arrows">
                <div className="arrow">
                  <i className="fal fa-chevron-right"></i>
                  <i className="fal fa-chevron-right"></i>
                  <i className="fal fa-chevron-right"></i>
                </div>

                <div className="arrow">
                  <i className="fal fa-chevron-right"></i>
                  <i className="fal fa-chevron-right"></i>
                  <i className="fal fa-chevron-right"></i>
                </div>
              </div>
            </div>

            <div className="assets">
              <div className="squares">
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
              </div>

              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/QQ9RuuafCBk?controls=0"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <Button>Faça seu cadastro agora mesmo</Button>
        </div>
      </section>

      <section id="about">
        <div className="content">
          <div className="heading">
            <h1>Nooio: Uma solução para <br />micro e grandes empreendedores</h1>
          </div>

          <div className="flex-about">
            <div className="text">
              <h2>O seu lucro é a nossa prioridade</h2>

              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti
                aliquam nobis ab fugit iste id sequi, quaerat exercitationem eaque
                corrupti cum cupiditate alias ratione reiciendis natus repudiandae
                magnam atque nam?
              </p>

              <img
                src={ImageArrowLine}
                alt="Arrow line dashed | Nooio"
                className="arrow-line-dashed"
              />
            </div>

            <div className="image">
              <img src={ImageAbout1} alt="About | Nooio" />
            </div>
          </div>

          <div className="flex-about flex-reverse">
            <div className="text">
              <h2>Alcance mais clientes sem <br />gastar muito</h2>

              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti
                aliquam nobis ab fugit iste id sequi, quaerat exercitationem eaque
                corrupti cum cupiditate alias ratione reiciendis natus repudiandae
                magnam atque nam?
              </p>
            </div>

            <div className="image">
              <img src={ImageAbout2} alt="About | Nooio" />
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials">
        <div className="content">
          <div className="heading">
            <h1>O que os nossos <br />clientes estão dizendo?</h1>
          </div>

          <div className="testimonials">
            <Swiper 
              spaceBetween={30}
              slidesPerView={2}
              slidesPerColumn={2}
              slidesPerColumnFill="row"
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000, }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                540: {
                  slidesPerView: 2,
                }
              }}
            >
              <SwiperSlide>
                <img src="./assets/aspas.svg" alt="Aspas" className="aspas" />
                <div className="people">
                  <img
                    src="http://www.editora2b.com.br/images/b/Ricardo_Ubrig.jpg"
                    alt="Ricardo Ubrig | Testimonial"
                  />

                  <div className="info">
                    <strong>Ricardo Ubrig</strong>
                    <span>Diretor Comercial - Ifood</span>
                  </div>
                </div>

                <div className="what-said">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Vitae magni maxime provident fuga velit, neque, omnis
                    dolorem reiciendis animi nemo veritatis ipsum laboriosam aut
                    nobis, soluta fugit.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <img src="./assets/aspas.svg" alt="Aspas" className="aspas" />
                <div className="people">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2Ex5U4og2Yzi3fButRoqu0Y_hrYOjqO0sFw&usqp=CAU"
                    alt="Thaís Azevedo | Testimonial"
                  />

                  <div className="info">
                    <strong>Thaís Azevedo</strong>
                    <span>Head of Marketing Uber Eats Latam</span>
                  </div>
                </div>

                <div className="what-said">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Vitae magni maxime provident fuga velit, neque, omnis
                    dolorem reiciendis animi nemo veritatis ipsum laboriosam aut
                    nobis, soluta fugit.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <img src="./assets/aspas.svg" alt="Aspas" className="aspas" />
                <div className="people">
                  <img
                    src="https://www.sinaprosp.org.br/wp-content/uploads/2021/04/Gustavo-Fehlberg_Burger-King.jpg"
                    alt="Gustavo Fehlberg | Testimonial"
                  />

                  <div className="info">
                    <strong>Gustavo Fehlberg</strong>
                    <span>Diretor Executivo - Burger King do Brasil</span>
                  </div>
                </div>

                <div className="what-said">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Vitae magni maxime provident fuga velit, neque, omnis
                    dolorem reiciendis animi nemo veritatis ipsum laboriosam aut
                    nobis, soluta fugit.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <img src="./assets/aspas.svg" alt="Aspas" className="aspas" />
                <div className="people">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxtJLkwXmpEVYZSQRVqiNw3BmEmsokrZHNGj6z6iW5cPFW5L0SURxrDFw-ApSUiPzoyvM&usqp=CAU"
                    alt="Antonio Detsi | Testimonial"
                  />

                  <div className="info">
                    <strong>Antonio Detsi</strong>
                    <span>Diretor Geral - Bob's</span>
                  </div>
                </div>

                <div className="what-said">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Vitae magni maxime provident fuga velit, neque, omnis
                    dolorem reiciendis animi nemo veritatis ipsum laboriosam aut
                    nobis, soluta fugit.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <img src="./assets/aspas.svg" alt="Aspas" className="aspas" />
                <div className="people">
                  <img
                    src="https://voxnews.com.br/wp-content/uploads/2021/01/IMG_0320.jpg"
                    alt="Fernando Vilela | Testimonial"
                  />

                  <div className="info">
                    <strong>Fernando Vilela</strong>
                    <span>Diretor de estratégia do Rappi</span>
                  </div>
                </div>

                <div className="what-said">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Vitae magni maxime provident fuga velit, neque, omnis
                    dolorem reiciendis animi nemo veritatis ipsum laboriosam aut
                    nobis, soluta fugit.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <img src="./assets/aspas.svg" alt="Aspas" className="aspas" />
                <div className="people">
                  <img
                    src="https://s3.amazonaws.com/brt.org/CK-3.jpg"
                    alt="Chris Kempczinski | Testimonial"
                  />

                  <div className="info">
                    <strong>Chris Kempczinski</strong>
                    <span>CEO - McDonald's</span>
                  </div>
                </div>

                <div className="what-said">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Vitae magni maxime provident fuga velit, neque, omnis
                    dolorem reiciendis animi nemo veritatis ipsum laboriosam aut
                    nobis, soluta fugit.
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      <section id="faq">
        <div className="content">
          <div className="asset">
            <img src={ImageFaq} alt="Faq | Nooio" />
          </div>

          <div className="faq-container">
            <div className="heading">
              <h1>F.A.Q</h1>
              <p>
                Tire todas as suas duvidas, caso ainda fique com dúvidas entre
                contato para podermos ajudar.
              </p>
            </div>

            <div className="faq-items">
              <div className="faq-item">
                <div className="question">
                  <span>1. Como funciona o Minisite.delivery?</span>

                  <i className="far fa-chevron-down"></i>
                </div>

                <div className="answer"></div>
              </div>

              <div className="faq-item">
                <div className="question">
                  <span>1. Como funciona o Minisite.delivery?</span>

                  <i className="far fa-chevron-down"></i>
                </div>

                <div className="answer"></div>
              </div>

              <div className="faq-item">
                <div className="question">
                  <span>1. Como funciona o Minisite.delivery?</span>

                  <i className="far fa-chevron-down"></i>
                </div>

                <div className="answer"></div>
              </div>

              <div className="faq-item">
                <div className="question">
                  <span>1. Como funciona o Minisite.delivery?</span>

                  <i className="far fa-chevron-down"></i>
                </div>

                <div className="answer"></div>
              </div>

              <div className="faq-item">
                <div className="question">
                  <span>1. Como funciona o Minisite.delivery?</span>

                  <i className="far fa-chevron-down"></i>
                </div>

                <div className="answer"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="lasted-posts">
        <div className="content">
          <div className="squares">
              <div className="square first"></div>
              <div className="square second"></div>
              <div className="square third"></div>
              <div className="square fourth"></div>
              <div className="square fifth"></div>
          </div>

          <div className="squares">
              <div></div>
              <div className="square first"></div>
              <div className="square second"></div>
              <div className="square third"></div>
              <div className="square fourth"></div>
              <div className="square fifth"></div>
          </div>

          <div className="heading">
            <h1>Ultimas postagens do nosso <br />blog, confira a seguir</h1>
          </div>

          <div className="wrapper">
            <div className="posts">
              <div className="post">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkzBMG9in9wSO5O5a7I0Jm0ZrWI1GutsjRsQ&usqp=CAU" alt="" />

                  <div className="text">
                      <a href="#see">
                          <span>Ler agora</span>
                          <i className="far fa-arrow-right"></i>
                      </a>
                      <span>by Milton Meira</span>
                      <strong>Embalagens sustentáveis</strong>
                      <p>Esta tendência já não era novidade alguma, haja vista que a consciência ecológica é forte em todo o mundo...</p>
                  </div>
              </div>
              
              <div className="post">
                  <img src="https://i0.wp.com/pt.techbriefly.com/wp-content/uploads/2021/04/O-Google-Assistente-esta-apresentando-novos-recursos-de-comando-de.jpg?fit=758%2C426&ssl=1" alt="" />

                  <div className="text">
                      <a href="#see">
                          <span>Ler agora</span>
                          <i className="far fa-arrow-right"></i>
                      </a>
                      <span>by Milton Meira</span>
                      <strong>Pedidos por comando de voz</strong>
                      <p>Imagine fazer pedidos por comando de voz! Sim, isso já é realidade mundo afora, e não vai demorar...</p>
                  </div>
              </div>
              
              <div className="post">
                  <img src="https://nutrativa.com.br/wp-content/uploads/2020/03/03012020-fonte-de-prote%C3%ADna-banner-1024x512.jpg" alt="" />

                  <div className="text">
                      <a href="#see">
                          <span>Ler agora</span>
                          <i className="far fa-arrow-right"></i>
                      </a>
                      <span>by Milton Meira</span>
                      <strong>Proteína vegana</strong>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil iusto similique, commodi, quod beatae.</p>
                  </div>
              </div>
              
              <div className="post">
                  <img src="http://abrasel.com.br/revista/site/assets/files/1153/delivery_dark_kitchens.jpg" alt="" />

                  <div className="text">
                      <a href="#see">
                          <span>Ler agora</span>
                          <i className="far fa-arrow-right"></i>
                      </a>
                      <span>by Milton Meira</span>
                      <strong>Dark Kitchens</strong>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil iusto similique, commodi, quod beatae.</p>
                  </div>
              </div>
              
            </div>
          </div>
        </div>
      </section>

      <section id="newsletter">
        <div className="content">
          <div className="newsletter">
            <div>
              <h2>Newsletter Nooio</h2>
              <h1>Fique por dentro de tudo</h1>
            </div>

            <form>
              <div className="input">
                <input
                  type="text"
                  name="email"
                  placeholder="Digite seu melhor e-mail..."
                />
              </div>
              <Button type="submit">Enviar</Button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </LandingContainer>
  );
};

export default Landing;
